import { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

const FIVE_HOURS_MS = 5 * 60 * 60 * 1000;

const useQRManager = (userID) => {
const { api } = useContext(GlobalContext);

  const [qrCode, setQrCode] = useState("");
  const [qrLinkVolunteer, setQrLinkVolunteer] = useState("");
  const [qrLoading, setQrLoading] = useState(false);

  // ── Fetch main QR Code ──────────────────────────────────
  useEffect(() => {
    if (!userID) return;

    const fetchQR = async () => {
      try {
        const res = await api.post(
  "/Whatsapp/getQRCode",
  { userid: userID }
);

        if (res.data.responseCode === "00") {
          setQrCode(res.data.response.qr_image_url);
        }
      } catch (err) {
        console.error("QR Code Error:", err);
      }
    };

    fetchQR();
  }, [userID, api]);

  // ── Volunteer QR — auto load from session or generate ──
  useEffect(() => {
    if (!userID) return;

    const savedLink = sessionStorage.getItem(`qr_token_link_${userID}`);
    const lastCall = sessionStorage.getItem(`qr_token_last_call_${userID}`);

    if (savedLink) {
      setQrLinkVolunteer(savedLink);
      return;
    }

    if (lastCall) {
      const elapsed = Date.now() - Number(lastCall);
      if (elapsed < FIVE_HOURS_MS) {
        return;
      }
    }

    const autoGenerate = async () => {
      setQrLoading(true);
      try {
       const res = await api.post(
  "/User/v1.0/generateToeknForQRGeneration",
  { shopCode: userID }
);

        if (res.data.responseCode === "00") {
          const link = res.data.data.link;
          setQrLinkVolunteer(link);
          sessionStorage.setItem(`qr_token_link_${userID}`, link);
          sessionStorage.setItem(`qr_token_last_call_${userID}`, Date.now().toString());
        }
      } catch (err) {
        console.error("Volunteer QR Auto-generate Error:", err);
      } finally {
        setQrLoading(false);
      }
    };

    autoGenerate();
  }, [userID, api]);

  const generateVolunteerQR = async () => {
    if (qrLoading) return;

    const lastCall = sessionStorage.getItem(`qr_token_last_call_${userID}`);
    if (lastCall) {
      const elapsed = Date.now() - Number(lastCall);
      if (elapsed < FIVE_HOURS_MS) {
        const remaining = FIVE_HOURS_MS - elapsed;
        const h = Math.floor(remaining / (1000 * 60 * 60));
        const m = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((remaining % (1000 * 60)) / 1000);
        toast.warn(`QR already generated. Try again in ${h}h ${m}m ${s}s`, {
          position: "top-center",
        });
        return;
      }
    }

    setQrLoading(true);

    try {
    const res = await api.post(
  "/User/v1.0/generateToeknForQRGeneration",
  { shopCode: userID }
);

      if (res.data.responseCode === "00") {
        const link = res.data.data.link;
        setQrLinkVolunteer(link);
        sessionStorage.setItem(`qr_token_link_${userID}`, link);
        sessionStorage.setItem(`qr_token_last_call_${userID}`, Date.now().toString());
        toast.success("QR generated successfully", { position: "top-center" });
      } else {
        toast.error("Failed to generate QR", { position: "top-center" });
      }
    } catch (err) {
      console.error("Volunteer QR Error:", err);
      toast.error("Something went wrong", { position: "top-center" });
    } finally {
      setQrLoading(false);
    }
  };

  return {
    qrCode,
    qrLinkVolunteer,
    generateVolunteerQR,
    qrLoading,
  };
};

export default useQRManager;